import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { NovautRunsCard } from "@/components/novaut-runs-card";

const STATUS_POLL_INTERVAL_MS = 30_000;

export function NovautPage() {
  const status = useQuery({
    queryKey: ["novaut-status"],
    queryFn: () => api.novautStatus(),
    refetchInterval: STATUS_POLL_INTERVAL_MS,
  });
  const fileRunRefusal = status.data
    ? status.data.fileRunRefusal
    : status.isError
      ? "The status could not be loaded"
      : "The status is loading";

  return <NovautRunsCard fileRunRefusal={fileRunRefusal} />;
}
